import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BlobUrlManager } from '@osapp/components/image/model/BlobUrlManager';

@Component({
  selector: 'di-confirmation-maj-app',
  templateUrl: './confirmation-maj-app.component.html',
  styleUrls: ['./confirmation-maj-app.component.scss'],
})
export class ConfirmationMajAppComponent implements OnInit {

	isLargeScreen: boolean = false;
	private readonly moBlobUrlManager = new BlobUrlManager();

  constructor() {}

  ngOnInit(): void {
	
  }
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
  

}
